import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Modal, Alert } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

// To handle requests
import UsersAPI from '../utils/UsersAPI';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';

import { namespace } from '../../../config.json';

class DeleteUserButtonComponent extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            errorText: null,
            modalErrorAlert: '',
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submit = this.submit.bind(this);
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true });
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({
            showModal: false,
            errorText: null,
            modalErrorAlert: '',
        });
    }

    // Fired when modal is submitted
    submit() {
        // Launching delete user action
        UsersAPI.deleteUser(this.props.username).then(() => {
            this.closeModal();
            // Calling specified callback if any
            if (this.props.callback) {
                this.props.callback();
            }
        }).catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            } else {
                this.setState({
                    modalErrorAlert: message.response.body.error,
                });
            }
        });
    }

    render() {
        let errorAlert = null;

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger">
                        {this.state.modalErrorAlert}
                      </Alert>;
        }

        return (
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="top"
            overlay={
              <Tooltip id="deleteUserTooltip">
                Delete User
              </Tooltip>
          }>
            <button
              className="btn btn-primary btn-xs delete-user-btn"
              style={brandingStyles.buttons.primary}
              onClick={this.openModal}
            >
                <i className="fa fa-times"></i>

                <Modal show={this.state.showModal} onHide={this.closeModal}>
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-edit"
                              style={brandingStyles.mainColor}
                            ></i>
                            <span>&nbsp;</span>
                            Delete user
                            <span>&nbsp;</span>
                            {this.props.username}
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={brandingStyles.backgrounds.panel}>
                        <p>Are you sure you want to delete user
                            <strong>&nbsp;{this.props.username}</strong>
                            ?
                        </p>
                        <div className="alert alert-warning">
                            <strong>
                                <i className="fa fa-exclamation-triangle"

                                style={{
                                    color: 'orange',
                                }}></i>
                                <span>&nbsp;</span>
                                This cannot be undone</strong>
                        </div>
                        {errorAlert}
                    </Modal.Body>
                    <Modal.Footer style={brandingStyles.backgrounds.panel}>
                        <button
                          className="btn btn-primary"
                          style={brandingStyles.buttons.primary}
                          onClick={this.submit}>
                            Proceed
                        </button>
                        <button
                          className="btn btn-primary"
                          style={brandingStyles.buttons.primary}
                          onClick={this.closeModal}>
                            Cancel
                        </button>
                    </Modal.Footer>
                </Modal>
            </button>
          </OverlayTrigger>
        );
    }

}

// Username is mandatory for delete operation to work
DeleteUserButtonComponent.propTypes = {
    username: PropTypes.string.isRequired,
    callback: PropTypes.func,
};

export default DeleteUserButtonComponent;



/** WEBPACK FOOTER **
 ** ./src/components/DeleteUserButton.js
 **/